import PlanningDayDTO from "@shared-dto/planning/planning.day.dto";
import type Session from "@shared-models/planning/session.model";
import type UserSession from "@shared-models/planning/user.session.model";

const updatePlanningDays = async (planningByDayIso: PlanningDayDTO[], daysIso: string[], fetchPlanningByDates: (daysIso: string[]) => Promise<PlanningDayDTO[]>, force: boolean = false): Promise<PlanningDayDTO[]> =>
{
	const daysToFetch: string[] = [];

	for (const dayIso of daysIso)
	{
		const existingDayIndex = planningByDayIso.findIndex(v => v.dayIso == dayIso);

		if (existingDayIndex == -1 || force)
		{
			daysToFetch.push(dayIso);
		}
	}

	if (daysToFetch.length > 0)
	{
		const result = await fetchPlanningByDates(daysToFetch);

		for (const planningDay of result)
		{
			const existingDayIndex = planningByDayIso.findIndex(v => v.dayIso == planningDay.dayIso);

			if (existingDayIndex == -1)
			{
				planningByDayIso.push(planningDay);
			}
			else
			{
				// Toujours remplacer (même si force=true) — sinon doublons accumulés
				// dans le store à chaque force-refresh (bug visible : 5+ entrées pour
				// le même jour avec statuses divergents).
				planningByDayIso[existingDayIndex] = planningDay;
			}
		}
	}

	return planningByDayIso;
};

const updatePlanningDay = async (planningByDayIso: PlanningDayDTO[], dayIso: string, fetchPlanningByDate: (dayIso: string) => Promise<PlanningDayDTO | null>, force: boolean = false): Promise<PlanningDayDTO[]> =>
{
	const existingDayIndex = planningByDayIso.findIndex(v => v.dayIso == dayIso);

	if (existingDayIndex == -1 || force)
	{
		const result = await fetchPlanningByDate(dayIso);

		if (result)
		{
			if (existingDayIndex == -1)
			{
				planningByDayIso.push(result);
			}
			else
			{
				planningByDayIso[existingDayIndex] = result;
			}

			if (planningByDayIso.length > 10)
			{
				//planningByDayIso.shift(); // Supprime le plus ancien (en premier dans le tableau)
			}
		}
	}

	return planningByDayIso;
};

/**
 * Patch en place le userSession d'une session précise dans le cache planningByDayIso.
 * Utilisé pour propager une modif locale (note coach, workout notes…) sans
 * re-fetch côté serveur. Mutation in-place (Vue détecte les changements de propriété).
 */
const updateUserSessionInPlanning = (
	planningByDayIso: PlanningDayDTO[],
	sessionId: string,
	userSession: UserSession,
): PlanningDayDTO[] =>
{
	for (const day of planningByDayIso)
	{
		const item = day.content?.find(c => c.session?.id === sessionId);
		if (item)
		{
			item.userSession = userSession;
			break;
		}
	}
	return planningByDayIso;
};

/**
 * Patch en place la session (status calculé, stats, etc.) d'une session précise dans
 * le cache planningByDayIso. Utilisé pour propager les données d'un fetch /planning/:id
 * vers la grille /planning sans nouvelle requête : évite que /planning affiche un état
 * obsolète quand on revient après une cascade auto / modif sur /planning/:id.
 */
const updateSessionInPlanning = (
	planningByDayIso: PlanningDayDTO[],
	sessionId: string,
	session: Session,
): PlanningDayDTO[] =>
{
	for (const day of planningByDayIso)
	{
		const item = day.content?.find(c => c.session?.id === sessionId);
		if (item)
		{
			item.session = session;
			break;
		}
	}
	return planningByDayIso;
};

export {
	updatePlanningDays,
	updatePlanningDay,
	updateUserSessionInPlanning,
	updateSessionInPlanning,
};
